import { resolveHostUsingEnvironmentInfo } from '@experiences/util';
import urljoin from 'url-join';

export const getIdentityBaseRoute = (orgIdOrName: string, isHostMode: boolean) => {
    const identityBaseRoute = '/identity_';

    if (window.location.origin.includes('localhost')) {
        return urljoin('/', orgIdOrName, identityBaseRoute);
    }
    return `https://${window.env?.CIS_HOST_PREFIX || urljoin(resolveHostUsingEnvironmentInfo(window.location.host), isHostMode ? '' : orgIdOrName, identityBaseRoute)}`;
};

export function validateLanguageCode(languageCode: string): string {
    const language = languageCode?.toLowerCase();
    switch (language) {
        case 'en':
        case 'keys':
            return 'en';
        case 'ja':
            return 'ja';
        case 'fr':
            return 'fr';
        case 'de':
            return 'de';
        case 'es':
            return 'es';
        case 'pt-br':
            return 'pt-BR';
        case 'es-mx':
            return 'es-MX';
        case 'ko':
            return 'ko';
        case 'zh-cn':
            return 'zh-CN';
        case 'zh-tw':
            return 'zh-TW';
        case 'pt':
            return 'pt';
        case 'tr':
            return 'tr';
        case 'ro':
            return 'ro';
        case 'ru':
            return 'ru';
        default:
            return 'en';
    }
}
